<template>
  <div>
    <div v-if="!readOnly">
      <h4 class="mt-4">Parentesco {{ index }}</h4>
      <validation-observer ref="relationshipForm" class="col-12">
        <div class="row">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Nombre del Pariente:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomFirstName"
              rules="required"
            >
              <custom-input
                id="customFirstName"
                v-model="model.name"
                custom-error-msg="El nombre del pariente es requerido."
                :error="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Apellidos:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomLastName"
              rules="required"
            >
              <custom-input
                id="customLastName"
                v-model="model.lastName"
                custom-error-msg="El(los) apellido(s) es(son) requerido(s)."
                :error="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Parentesco:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomRelationship"
              rules="required"
            >
              <custom-drop-down
                id="customRelationship"
                v-model="model.relationshipType"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El parentesco es requerido."
                :error="errors[0]"
                :options="relationships"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Correo Electrónico:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                email: 'El correo electrónico no es válido.',
                required: 'El correo electrónico es requerido.'
              }"
              name="validationCustomEmail"
              rules="required|email"
            >
              <custom-input
                id="customEmail"
                type="email"
                v-model="model.email"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Teléfono 1:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                completePhone: 'El número teléfonico completo es requerido.',
                required: 'El telefóno 1 es requerido.'
              }"
              name="validationCustomPhone1"
              rules="required|completePhone"
            >
              <custom-input
                id="customPhone1"
                v-model="model.phone1"
                mask-type="Phone"
                :masked="false"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Teléfono 2:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                completePhone: 'El número teléfonico completo es requerido.'
              }"
              name="validationCustomPhone2"
              rules="completePhone"
            >
              <custom-input
                id="customPhone2"
                v-model="model.phone2"
                mask-type="Phone"
                :masked="false"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else class="pb-1 my-4">
      <callout :has-toggle="false" :controlled="true">
        <div class="row mt-3 mb-3">
          <div class="col-md-1 col-sm-12">
            <div class="phone-icon mt-2">
              <i class="fas fa-phone-alt"></i>
            </div>
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block mb-2">Nombre del Pariente:</span>
            <strong> {{ model.name }} {{ model.lastName }}</strong>
          </div>
          <!-- TODO. Revisar  -->
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block mb-2">Parentesco:</span>
            {{ model.relationshipType ? model.relationshipType.name : "-" }}
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block mb-2">Correo Electrónico:</span>
            {{ model.email }}
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block mb-2">Teléfono 1:</span>
            {{ setPhoneMask(model.phone1) }}
          </div>
          <div class="col-md-2 col-sm-12">
            <span class="data-title d-block mb-2">Teléfono 2:</span>

            {{ model.phone2 ? setPhoneMask(model.phone2) : "-" }}
          </div>
        </div>
      </callout>
    </div>
  </div>
</template>

<script>
// Components
import Callout from "custom-callout";
import CustomDropDown from "custom-drop-down";
import CustomDatePicker from "custom-date-picker";
import CustomInput from "CustomInput";
import IconView from "icon-view";

// Utils
import { masker, tokens } from "ke-the-mask";

export default {
  name: "registrationRelatioshipInformation",
  components: {
    Callout,
    CustomDropDown,
    CustomDatePicker,
    CustomInput,
    IconView
  },
  watch: {
    model: {
      handler(value) {
        this.$emit("input", value);
      }
    },
    info: {
      deep: true,
      immediate: true,
      handler(value) {
        this.model = value;
      }
    }
  },
  props: {
    info: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
        lastName: null,
        relationshipType: {
          name: null,
          sortOrder: 0,
          id: null,
          selected: false,
          disabled: false,
          isDirty: false,
          keyId: null
        },
        email: null,
        phone1: null,
        phone2: null,
        registrationId: null,
        RelationShipTypeId: null
      })
    },
    relationships: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: () => false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      model: {
        name: null,
        lastName: null,
        relationshipType: null,
        email: null,
        phone1: null,
        phone2: null
      }
    };
  },
  methods: {
    setPhoneMask(phone) {
      if (!phone) return phone;
      return masker(phone, "(###)###-####", true, tokens);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.phone-icon {
  display: inline-block;
  font-size: 18px;
  line-height: 32px;
  background-color: map.get($colors, "orange");
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  text-align: center;
  vertical-align: bottom;
}
</style>
